export function resolvePeopleBasePath(currentPathname: string): '/dashboard' | '/system/dashboard' {
  return currentPathname.startsWith('/system') ? '/system/dashboard' : '/dashboard';
}

export function personDetailPath(personId: string, currentPathname: string): string {
  return `${resolvePeopleBasePath(currentPathname)}/people/${personId}`;
}

export function subprofileDetailPath(parentId: string, subIndex: number | string, currentPathname: string): string {
  return `${resolvePeopleBasePath(currentPathname)}/people/${parentId}/sub/${subIndex}`;
}
